import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const auth = firebaseApp.auth();

export const db = firebaseApp.firestore();

export const storage = firebase.storage();

export interface HolisticFunctions {
  addClientSurvey(data: {
    clientId: string;
    templateId: string;
  }): Promise<firebase.functions.HttpsCallableResult>;
  createAdmin(data: {
    email: string;
  }): Promise<firebase.functions.HttpsCallableResult>;
  createClientAdmin(data: {
    clientId: string;
    email: string;
  }): Promise<firebase.functions.HttpsCallableResult>;
  exportSurveysAndEmployeeData(): Promise<
    firebase.functions.HttpsCallableResult
  >;
}

export const holisticFunctions: HolisticFunctions = {
  addClientSurvey: firebase.functions().httpsCallable('addClientSurvey'),
  createAdmin: firebaseApp.functions().httpsCallable('createAdmin'),
  createClientAdmin: firebaseApp.functions().httpsCallable('createClientAdmin'),
  exportSurveysAndEmployeeData: firebaseApp
    .functions()
    .httpsCallable('exportSurveysAndEmployeeData'),
};
